import { Platform } from 'react-native'
import * as Sentry from 'sentry-expo'

export const mySentry = () => {
  if (Platform.OS === 'web') {
    return Sentry.Browser
  }
  return Sentry.Native
}
